module.exports = __webpack_public_path__ + "st_lucia.f877d42bdbc88eea52f14e52c597d033.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/st_lucia.svg
// module id = 1159
// module chunks = 0